import { ProfileFieldModel } from "@/domains/profile/models/ProfileFieldModel";

export function ProfileTabModel(tab) {
    const { id, name, profileFields } = tab;
    const fields = [...profileFields];

    fields.sort((a, b) => a.sort - b.sort);
    return {
        id,
        name,
        fields: fields.map(ProfileFieldModel),
    };
}
